
export default function ServiceAreas() {
  const areas = [
    {
      name: 'Sağlık Tesisleri',
      items: ['Hastaneler', 'Klinikler', 'Tıp Merkezleri', 'Diş Hekimliği Ofisleri', 'Laboratuvarlar', 'Huzurevleri']
    },
    {
      name: 'Perakende Alanları',
      items: ['Alışveriş Merkezleri', 'Mağazalar', 'Butikler', 'Showroomlar', 'Süpermarketler', 'Perakende Merkezleri']
    },
    {
      name: 'Ticari Binalar',
      items: ['Ofis Binaları', 'Şirket Merkezleri', 'İş Merkezleri', 'Ortak Çalışma Alanları', 'Bankalar', 'Devlet Binaları']
    },
    {
      name: 'Konaklama',
      items: ['Oteller', 'Tatil Köyleri', 'Restoranlar', 'Kafeler', 'Etkinlik Mekanları', 'Konferans Merkezleri']
    },
    {
      name: 'Eğitim',
      items: ['Okullar', 'Üniversiteler', 'Eğitim Merkezleri', 'Kütüphaneler', 'Kreşler', 'Spor Salonları']
    },
    {
      name: 'Endüstriyel',
      items: ['Depolar', 'Üretim Tesisleri', 'Dağıtım Merkezleri', 'İnşaat Sahaları', 'Fabrikalar', 'Depolama Tesisleri']
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Hizmet Verdiğimiz Sektörler
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ticari temizlik uzmanlığımız birden fazla sektöre yayılır ve çeşitli tesis türleri ve gereksinimleri için özel çözümler sunar.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {areas.map((area, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <i className="ri-building-4-line text-teal-600 mr-3"></i>
                {area.name}
              </h3>
              <ul className="space-y-3">
                {area.items.map((item, idx) => (
                  <li key={idx} className="flex items-center text-gray-700">
                    <i className="ri-checkbox-circle-line text-teal-600 mr-3"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-gray-600 mb-6">
            Sektörünüzü listede görmüyor musunuz? Tüm ticari alanlar için özelleştirilmiş temizlik çözümleri sunuyoruz.
          </p>
          <button className="bg-teal-600 text-white px-8 py-4 rounded-lg hover:bg-teal-700 transition-colors text-lg font-semibold whitespace-nowrap cursor-pointer">
            Özel Çözümler İçin Bize Ulaşın
          </button>
        </div>
      </div>
    </section>
  );
}
